module.exports = __webpack_public_path__ + "./images/10d230a526fc21325bdccb71aa4061a4.webp";